import Axios from 'axios';

import { useContext, useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { toast } from "react-toastify";
import DashboardContext from '../../../Context';

/**این کامپوننت برای تاییدنیرو به
 *  vIP
 *  است */
const ModalConfermWorker = ({ show, id, handelClose, name, upDatae }) => {

    const { urldashboard, authentication } = useContext(DashboardContext);

    const [loading, setLoading] = useState(false)

    const handelSubmit = async () => {
        setLoading(true)

        try {
            const res = await Axios.put(`${urldashboard}/workervip/confirm`, JSON.stringify({ id }), {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })

            const DataRes = await res.data;

            toast.success(DataRes.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false)
            handelClose();
            upDatae()
        } catch (error) {

            if (error.message === 'Network Error') {
                toast.error('اینترنت قطع است لطفا وضعیت اینترنت را بررسی کنید:(', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setLoading(false)
            }
            else {
                setLoading(false)
                toast.error(error.response.data.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }


    }
    return (
        <Modal show={show} onHide={handelClose} >
            <Modal.Header>
                <Modal.Title>تایید نیرو VIP</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h3>{`آیا از VIP کردن ${name} مطمئن هستید ؟`}</h3>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handelClose} disabled={loading} variant="danger" >خیر</Button>
                <Button onClick={handelSubmit} disabled={loading} variant="success" className=' mr-auto ' >
                    {
                        loading ?
                            <i className="fa fa-spinner fa-pulse fa-fw"></i>

                            : "بله"
                    }

                </Button>
            </Modal.Footer>
        </Modal >
    );
}

export default ModalConfermWorker;
